import { useState } from "react";
import { Share, SquarePlus, Smartphone, Compass } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isIOS = () => {
  const ua = navigator.userAgent || "";
  const ios = /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  const standalone = window.navigator.standalone === true || window.matchMedia?.("(display-mode: standalone)").matches;
  return ios && !standalone;
};

const STEPS = [
  { icon: Compass, text: "Abra no Safari" },
  { icon: Share, text: "Toque no botão compartilhar (quadrado com seta)" },
  { icon: SquarePlus, text: "Toque em Adicionar à Tela de Início" },
  { icon: Smartphone, text: "Toque em Adicionar" },
];

export const IOSInstallGuide = () => {
  const [show] = useState(isIOS);
  const [open, setOpen] = useState(false);
  if (!show) return null;
  return (
    <>
      <button type="button" data-testid="ios-install-button" onClick={() => setOpen(true)}
        className="mt-3 w-full h-12 flex items-center justify-center gap-2 bg-[#0F1520] border border-emerald-500/40 text-emerald-300 font-medium rounded-xl hover:bg-emerald-500/10 transition-colors">
        <Share className="w-4 h-4" /> Instalar no iPhone
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="ios-install-guide" className="bg-[#181F2C] border-[#263147] text-slate-100 rounded-2xl w-[95vw] max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-heading">Instalar no iPhone</DialogTitle>
            <DialogDescription className="text-slate-400">Adicione o app à tela inicial em 4 passos:</DialogDescription>
          </DialogHeader>
          <ol className="space-y-2.5">
            {STEPS.map((s, i) => (
              <li key={s.text} data-testid={`ios-install-step-${i + 1}`} className="flex items-center gap-3 bg-[#0F1520] border border-[#263147] rounded-xl px-3 py-2.5">
                <span className="w-7 h-7 shrink-0 rounded-full bg-emerald-500/15 text-emerald-400 text-sm font-bold flex items-center justify-center">{i + 1}</span>
                <s.icon className="w-4 h-4 text-slate-400 shrink-0" />
                <span className="text-sm text-slate-200">{s.text}</span>
              </li>
            ))}
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
